import { Box, BoxProps } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

export enum LegacyFAIcons {
  Attachment = 'fa-paperclip',
  Bell = 'fa-bell',
  BellOutlined = 'fa-bell-o',
  Delete = 'fa-trash-o',
  CalendarPlus = 'fa-calendar-plus-o',
  Check = 'fa-check',
  Circle = 'fa-circle',
  Clear = 'fa-undo',
  Clock = 'fa-clock-o',
  Close = 'fa-close',
  Cog = 'fa-cog',
  Down = 'fa-caret-down',
  Edit = 'fa-pencil-square-o',
  EnvelopeOutlined = 'fa-envelope-o',
  EyeSlash = 'fa-eye-slash',
  File = 'fa-file-text-o',
  Flag = 'fa-flag-o',
  Frown = 'fa-frown-o',
  Globe = 'fa-globe',
  ImageFile = 'fa-file-image-o',
  Info = 'fa-info',
  Key = 'fa-key',
  List = 'fa-list',
  ListAlt = 'fa-list-alt',
  Lock = 'fa-lock',
  Meh = 'fa-meh-o',
  MinusSquare = 'fa-minus-square',
  Mobile = 'fa-mobile',
  Plus = 'fa-plus',
  PlusSquare = 'fa-plus-square',
  Print = 'fa-print',
  QuestionMark = 'fa-question-circle-o',
  Refresh = 'fa-refresh',
  Reject = 'fa-times',
  Save = 'fa-floppy-o',
  Search = 'fa-search',
  SignOut = 'fa-sign-out',
  Sitemap = 'fa-sitemap',
  Smile = 'fa-smile-o',
  Table = 'fa-th-list',
  Tachometer = 'fa-tachometer',
  User = 'fa-user',
  UserPlus = 'fa-user-plus',
  Users = 'fa-users',
  VideoCamera = 'fa-video-camera',
  Wrench = 'fa-wrench',

  Asc = 'fa-sort-asc',
  Desc = 'fa-sort-desc',
}

export enum LegacyFASize {
  X1 = 'fa-1x',
  X2 = 'fa-2x',
  X4 = 'fa-4x',
}

type Props = BoxProps & {
  FAIcon: LegacyFAIcons | string;
  FASize?: LegacyFASize | string;
};

export const LegacyFAIcon = (props: Props) => {
  const { FAIcon, FASize, className, component, ...boxProps } = props;

  return (
    <Box
      {...boxProps}
      component={!!component ? component : 'i'}
      className={classNames('fa', FAIcon, FASize, className)}
    />
  );
};
